import {setPageInfo, resetOffset} from "../Functions/Helpers";
import React, {useContext} from "react";
import {WooContext} from "../WooContext";

function ProductSortByOption() {
    const {orderByState, pagedState} = useContext(WooContext);
    const [orderBy, setOrderBy] = orderByState;
    const [,setPaged] = pagedState;
    return (
        <div className="products-option">
            <span>Sort by</span>
            <select value={orderBy.field}
                onChange={(e) => {
                e.preventDefault();
                setOrderBy({field: e.target.value, order: e.target.value === 'PRICE' ? 'ASC' : 'DESC'});
                resetOffset(setPaged);
                setPageInfo(window.location.pathname);}}
            >
                <option value="DATE">Newest</option>
                <option value="PRICE">Price</option>
                <option value="TOTAL_SALES">Popularity</option>
            </select>
        </div>
    )
}

export default ProductSortByOption;